import { ConnectedProps, connect } from 'react-redux'
import { ButtonPrimaryInfoLeft } from '../../../../../../baseComponents/Button'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import PermissionChecker from '../../../../../../baseComponents/PermissionChecker'
import { BaseScreenTableSimpleStateless, useBaseScreenTableLogic } from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { BaseScreenPageData } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import withLoading from '../../../../../../utils/hoc/withLoading'
import { SetEditDeleteModalTy } from '../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import useUpdateTableInstance from '../../../../../../utils/hooks/useUpdateTableInstance'
import { AllReduxPayloads } from '../../../../../../utils/reducers'
import { SpecificPriceRulesPayload } from '../../../../../../utils/reducers/products/specificPriceRules'
import ModalChangeActiveAddon from './ModalChangeActiveAddon'
import ModalCreateAddonConnect from './ModalCreateAddon'
import TableAddons from '../../../../../../specificComponents/Product/Tables/TableAddons'
import { faPlus } from '@fortawesome/pro-light-svg-icons'
import TwinIcon from '../../../../../../baseComponents/TwinIcon'

type AddonsProps = ComponentWithPermissions & ReduxAddons & {}

const Addons: React.FC<AddonsProps> = ({ userPermissions, ...button }) => {
    const { openModal, setOpenModal, tableInstance, setTableInstance } = useBaseScreenTableLogic()
    const { updateTableInstance } = useUpdateTableInstance({ tableInstance })
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('addons', 'Complementos'),
        newText: t('newAddon', 'Nuevo complemento'),
    }

    return (
        <BaseScreenTableSimpleStateless TableComponent={TableAddonsConnect} {...{ pageData, userPermissions, updateTableInstance }} CreateModalComponent={ModalCreateAddonConnect} DeleteModalComponent={ModalChangeActiveAddon} logicProps={{ openModal, setOpenModal, tableInstance, setTableInstance }} RightHeader={
            <RightHeaderAddonsTable {...{ pageData, setOpenModal, ...button, userPermissions }} />
        }>
        </BaseScreenTableSimpleStateless>)
}

type RightHeaderAddonsTableProps = ComponentWithPermissions & ReduxAddons & {
    pageData: BaseScreenPageData
    setOpenModal: SetEditDeleteModalTy
}

const RightHeaderAddonsTable: React.FC<RightHeaderAddonsTableProps> = ({ pageData, userPermissions, specificPriceRules, setOpenModal }) => {
    const { t } = useTwinTranslation()
    return (
        <PermissionChecker userPermissions={userPermissions} permission='create'>
            {pageData.newText ? <ButtonPrimaryInfoLeft onClick={async () => setOpenModal({ type: 'create', allRowData: {} })} textButton={<span><TwinIcon icon={faPlus} className='mr-8' />{pageData.newText}</span>} buttonIsDisabled={specificPriceRules?.arrSorted?.length === undefined || specificPriceRules?.arrSorted?.length === 0} infoMessage={t('needCreatePriceRulesBefore', 'Debes crear un grupo de tarifas antes')} /> : null}
        </PermissionChecker>
    )
}

const addonsDispatch = {
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
}

const mapAddonsConnector = (state: AllReduxPayloads) => ({ specificPriceRules: state.specificPriceRules })
const addonsConnect = connect(mapAddonsConnector, addonsDispatch)
type ReduxAddons = ConnectedProps<typeof addonsConnect>

const addonsConnectLoading = withLoading(Addons, [{ fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }])
const AddonsConnect = addonsConnect(addonsConnectLoading)


const tableAddonsDispatch = {
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
}

const mapTableAddonsConnector = (state: AllReduxPayloads) => ({ specificPriceRules: state.specificPriceRules })
const tableAddonsConnect = connect(mapTableAddonsConnector, tableAddonsDispatch)

const tableAddonsConnectLoading = withLoading(TableAddons, [{ fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }])
const TableAddonsConnect = tableAddonsConnect(tableAddonsConnectLoading)

export default AddonsConnect